import React from 'react'
import './HeaderStyle.css'
function Header() {
  return (
    <div className='header-content'>
        <div id='main-header'>
           Your todo-List
        </div>
        <div id='sub-header'>
            Get started with adding you Todo's
        </div>
    </div>
  )
}

export default Header